// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");

function makeVariant(t) {
  switch (t) {
    case /* CarouselArrow */1 :
    case /* Modal */8 :
        return 10;
    case /* OverlayEventZone */9 :
        return 3;
    case /* RedirectionAnchor */11 :
        return -1;
    case /* SliderArrow */13 :
        return 25;
    case /* Header */7 :
    case /* Teaser */16 :
        return 100;
    case /* RedirectionAnchorFocused */12 :
    case /* TooltipUserPref */17 :
    case /* TopBanner */18 :
        return 2;
    case /* Badge */0 :
    case /* CarouselBullet */2 :
    case /* ContentCollection */3 :
    case /* Cta */4 :
    case /* EbuBox */5 :
    case /* Gradient */6 :
    case /* PaginatedGrid */10 :
    case /* SliderTeaser */14 :
    case /* StickerDisabledTime */15 :
    case /* TopTeaser */19 :
        return 1;
    
  }
}

function make(t) {
  switch (t.TAG | 0) {
    case /* Exact */0 :
        return makeVariant(t._0);
    case /* Above */1 :
        return makeVariant(t._0) + 1 | 0;
    case /* Behind */2 :
        return makeVariant(t._0) - 1 | 0;
    
  }
}

function toCss(t) {
  return CssJs.zIndex(make(t));
}

var Particle_zIndex_Css = {
  toCss: toCss
};

exports.makeVariant = makeVariant;
exports.make = make;
exports.Particle_zIndex_Css = Particle_zIndex_Css;
/* CssJs Not a pure module */
